
import { Ajax, AjaxError, ISupportSpinner } from '../shared/Ajax';

import {TierRequirementConfigModel} from '../models/TierRequirementConfigModel'
import {MilestoneReportModel} from '../models/MilestoneReportModel'
import {MilestoneModel} from '../models/MilestoneModel'
import {MilestoneSubmission} from '../models/MilestoneSubmission'
import {MilestoneReportDTO} from '../models/MilestoneReportDTO'
import {BSB} from '../models/BSB'
import { EligibleExpenditureCategory } from '../models/EligibleExpenditureCategory'

export class MilestoneReportController extends Ajax {
    constructor() {
        super(window.__emdgBaseUrl, '/api/milestonereport');
    }
    
        create(owner:ISupportSpinner, applicationId:string, grantAgreementID:string, reportingRequirementId:string, reportingPeriodStartDate:Date, reportingPeriodEndDate:Date, success:{(res:string):any}, error?:AjaxError) {
    super._call('post', '', owner, {applicationId:applicationId,grantAgreementID:grantAgreementID,reportingRequirementId:reportingRequirementId,reportingPeriodStartDate:reportingPeriodStartDate,reportingPeriodEndDate:reportingPeriodEndDate}, null, success, error, 'text')
}

        delete(owner:ISupportSpinner, milestoneReportId:string, success:{():any}, error?:AjaxError) {
    super._call('delete', 'Delete', owner, {milestoneReportId:milestoneReportId}, null, success, error, 'text')
}

        getComplianceByTier(owner:ISupportSpinner, isPeakIndustryBody:boolean, tier:number, grantProgramRoundId:string, year:string, success:{(res:TierRequirementConfigModel[]):any}, error?:AjaxError) {
    super._call('get', 'GetComplianceByTier', owner, {isPeakIndustryBody:isPeakIndustryBody,tier:tier,grantProgramRoundId:grantProgramRoundId,year:year}, null, success, error)
    }

        getEligibleExpenseCategory(owner: ISupportSpinner, success: { (res:EligibleExpenditureCategory[]): any }, error?: AjaxError) {
    super._call('get', 'GetEligibleExpenseCategory', owner, null, null, success, error)
}

        getMilestoneReportData(owner:ISupportSpinner, milestoneReportId:string, success:{(res:MilestoneReportModel):any}, error?:AjaxError) {
    super._call('get', 'GetMilestoneReportData', owner, {milestoneReportId:milestoneReportId}, null, success, error)
}

        saveMilestoneReport(owner:ISupportSpinner, model:MilestoneModel, success:{(res:MilestoneModel):any}, error?:AjaxError) {
    super._call('put', 'SaveMilestoneReport', owner, null, model, success, error)
}

        submit(owner:ISupportSpinner, model:MilestoneSubmission, success:{(res:MilestoneReportDTO):any}, error?:AjaxError) {
    super._call('put', 'submit', owner, null, model, success, error)
}

        bsbSearch(owner:ISupportSpinner, searchTxt:string, success:{(res:BSB):any}, error?:AjaxError) {
    super._call('get', 'bsbsearch', owner, {searchTxt:searchTxt}, null, success, error)
}

        updateOverseasRepresentative(owner:ISupportSpinner, model:MilestoneModel, success:{(res:MilestoneModel):any}, error?:AjaxError) {
    super._call('put', 'UpdateOverseasRepresentative', owner, null, model, success, error)
}

        updateMilestoneConsultant(owner:ISupportSpinner, model:MilestoneModel, success:{(res:MilestoneModel):any}, error?:AjaxError) {
    super._call('put', 'UpdateMilestoneConsultant', owner, null, model, success, error)
}
}
